import { useMemo } from 'react';
import { CHANNEL_THEMES } from 'core/constants/theme.constants';
import { EChannel } from 'core/model/enums/channel.enum';
import { authSelector } from 'core/store/auth/selectors';
import { useAppSelector } from 'core/store/store.utils';
import { getChannel } from 'core/utils/channel.utils';
import { getThemeByChannel } from 'shared/utils/theme.utils';

const useTheme = () => {
  const { customer } = useAppSelector(authSelector);

  const { id: channelIdFromStore, description: channelName } = customer?.channel ?? {};
  const channelIdFromStorage = Number(getChannel());

  const channelId = channelIdFromStore || (channelIdFromStorage as EChannel) || EChannel.ALICORP;

  const channelTheme = useMemo(() => CHANNEL_THEMES[channelId], [channelId]);
  const selectedTheme = useMemo(() => getThemeByChannel(channelId), [channelId]);

  return { channelId, channelName, channelIdFromStore, channelIdFromStorage, channelTheme, selectedTheme };
};

export default useTheme;
